// from: https://stackoverflow.com/a/29816921/3622350
export function msToMS(ms: number) {
  // Convert to seconds:
  let seconds = ms / 1000;
  // Extract minutes:
  let minutes = Math.floor(seconds / 60); // 60 seconds in 1 minute
  // Keep only seconds not extracted to minutes:
  seconds = seconds % 60;
  return numPad(minutes) + ":" + numPad(Math.floor(seconds));
}

function numPad(str: string | number, length: number = 2) {
  str = str + "";
  if (str.length < length) {
    let diff = length - str.length;
    str = "0".repeat(diff) + str;
  }
  return str;
}

// from: https://stackoverflow.com/a/2450976/3622350
export function shuffle<T>(array: T[]): T[] {
  let currIdx = array.length;

  // While there remain elements to shuffle...
  while (0 !== currIdx) {
    // Pick a remaining element...
    let randomIdx = Math.floor(Math.random() * currIdx);
    currIdx--;

    // And swap it with the current element.
    let tmpVal = array[currIdx];
    array[currIdx] = array[randomIdx];
    array[randomIdx] = tmpVal;
  }

  return array;
}

// Build classNames
// TODO: correctly type this function
export function bCN(...cNs: any[]) {
  if (cNs.length === 1 && Array.isArray(cNs[0])) cNs = cNs[0];
  const className = cNs
    .map((cn) => {
      if (Array.isArray(cn)) {
        const value = cn.pop();
        if (cn.some((cond) => cond === false)) return false;
        return value;
      }
      return cn;
    })
    .filter((cn) => !!cn)
    .join(" ");
  return { className };
}
